import Reactotron from "reactotron-react-js"

type Tron = {
  trackMstNode?: ((node?: any | undefined) => any) | undefined
  log?: ((message: any) => void) | undefined
}

export const reactotron: Tron = Reactotron.configure().connect()
